import { CModal } from "../index";

export declare type InputProps = {
    visible: boolean;
    setVisible: (text: boolean) => void;
    onOk: () => void;
    listUser: any[] ;
    listSelected: number[] ;
    selectUser:(text: any) => void;
}

export const ModalFilterUser = ({ visible, setVisible, onOk, listUser , selectUser , listSelected }: InputProps) => {

    return (
        <CModal visible={visible} setVisible={setVisible} width="280px" radius={'10px'} uId="Mo-selectuser">
            <div className=" w-full flex flex-col my-2 px2">
                <span className="mb-2">انتخاب کارمند</span>
                {listUser && listUser.map((item: any, index: number) =>
                    <div onClick={() => selectUser(item.id)} key={index} className=" flex items-center mt-2 mb-1  mx-2 cursor-pointer">
                        {(listSelected.length > 0 && listSelected.indexOf(item.id) != -1) ?
                            <div className={` w-[20px] h-[20px] rounded   bg-dayan-orange-50`} />
                            :
                            <div className={` w-[20px] h-[20px] rounded  border bg-none`} />
                        }
                        <span className="text-[12px] mr-2 text-gray-600">{item.name}</span>
                    </div>
                )}
                <div className=" w-full flex justify-center items-center mt-6">
                    <button onClick={onOk} className=" w-[80px] mx-2 h-[30px] bg-dayan-orange-50  flex items-center justify-center rounded-[5px] text-white">
                        <span>فیلتر</span>
                    </button>
                    <button onClick={()=>{setVisible(false)}} className="w-[80px] mx-2 h-[30px] bg-dayan-gray-200  flex items-center justify-center rounded-[5px] text-white">
                        <span>بستن</span>
                    </button>
                </div>
            </div>
        </CModal>
    );
}